<template>
    <div>
        <CCol sm="12" class="p-0">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CRow class="p-2">
    
                    <CCol sm="12">
                        <CCard class="bg-FFF custom-border-radius-12px">
                            <CRow class="justify-content-center m-2">
                                <CCol sm="2" @click="GoToSettingCompany()">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconCompany.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Company</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="GoToSettingLeave()">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconLeave.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Leave</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="GoToSettingClaim()">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconClaim.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Claim</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="GoToSettingDepartment()">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconDepartment.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Department</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="GoToSettingPayment()">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconPayment.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Payment</h3>
                                    </div>
                                </CCol>
                                </CRow>
                                <CRow class="justify-content-center">
                                <CCol sm="2" @click="GoToSettingNotification">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconNotification.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Notification</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="GoToSettingAttendance">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconAttendance.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Attendance</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="GoToSettingEvaluation">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconEvaluation.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Evaluation</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="GoToSettingSubscription">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconSubscription.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Subscription</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="GoToSettingYearlyForm">
                                    <div class="text-center m-3">
                                        <img src="../assets/icons/iconYearly.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Yearly Form</h3>
                                    </div>
                                </CCol>
    
                            </CRow>
                        </CCard>
                    </CCol>
    
                </CRow>
    
    
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            

        }





    },
    async mounted() {
        
            try {
                const isAuth = await this.UserAuth();
                if (isAuth) {
                    this.GetInfoUser();


                } else {
                    this.GoToPage();
                }
            } catch (error) {
                this.GoToPage();
                console.error("Error during authentication:", error);
                // Handle the error here
            }

    },

    computed: {

    },
    created() {
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        GoToSettingCompany()
        {
            this.$router.push("SettingCompany");
        },
        GoToSettingDepartment()
        {
            this.$router.push("SettingDepartment");
        },
        GoToSettingNotification()
        {
            this.$router.push("SettingNotification");
        },
        GoToSettingEvaluation()
        {
            this.$router.push("SettingEvaluation");
        },
        GoToSettingLeave()
        {
            this.$router.push("SettingLeave");
        },
        GoToSettingClaim()
        {
            this.$router.push("SettingClaim");
        },
        GoToSettingAttendance()
        {
            this.$router.push("SettingAttendance");
        },
        GoToSettingSubscription()
        {
            this.$router.push("SettingSubscription");
        },
        GoToSettingYearlyForm()
        {
            this.$router.push("SettingYearlyForm");

        },
        GoToSettingPayment()
        {
            this.$router.push("SettingPayment");

        }

       

    }

};
</script>